import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import CatalogoPage from './components/CatalogoPage';
import PerfilChica from './components/PerfilChica';
import Login from './components/Login';
import Registro from './components/Registro';
import MisCitas from './components/MisCitas';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/catalogo/:tipo" element={<CatalogoPage />} />
      <Route path="/catalogo" element={<CatalogoPage />} />
      <Route path="/chica/:id" element={<PerfilChica />} />
      <Route path="/login" element={<Login />} />
      <Route path="/registro" element={<Registro />} />
      <Route path="/mis-citas" element={<MisCitas />} />
    </Routes>
  </BrowserRouter>
);
